import type { RefObject } from 'react';

import { ChevronDown } from '@gds/Icons/Paths/ChevronDown';
import { ChevronTop } from '@gds/Icons/Paths/ChevronTop';

import styles from './Stepper.module.css';

type StepperProps = {
  onIncrement: () => void;
  onDecrement: () => void;
  label: string;
  focusTargetRef?: RefObject<HTMLInputElement | null>;
};

export function Stepper({
  onIncrement,
  onDecrement,
  label,
  focusTargetRef,
}: Readonly<StepperProps>) {
  const withFocus = (fn: () => void) => () => {
    fn();
    focusTargetRef?.current?.focus();
  };

  return (
    <div className={styles.stepper}>
      <button
        type="button"
        className={styles.stepperButton}
        aria-label={`Increase ${label}`}
        onMouseDown={e => e.preventDefault()}
        onClick={withFocus(onIncrement)}
      >
        <ChevronTop fontSize={16} />
      </button>
      <button
        type="button"
        className={styles.stepperButton}
        aria-label={`Decrease ${label}`}
        onMouseDown={e => e.preventDefault()}
        onClick={withFocus(onDecrement)}
      >
        <ChevronDown fontSize={16} />
      </button>
    </div>
  );
}
